import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import s from './CreateProposalModal.scss'
import { EditProposalTemplate } from 'components/common/modals/CreateProposalFromTemplateModalContainer/EditProposalTemplate'

const CreateProposalModal = ({
  setIsCreateProposalModalVisible,
  isCreateProposalModalVisible,
  saveTemplate,
  setIsEditedTemplate,
  template,
  templateType
}) => {
  return (
    <>
      <Modal
        keyboard={false}
        backdrop="static"
        isOpen={isCreateProposalModalVisible}
        toggle={() => {
          setIsCreateProposalModalVisible(!isCreateProposalModalVisible)
          setIsEditedTemplate(null)
        }}
        size="xl"
        className={s.modal}
        data-cy="add_proposal_template_modal"
      >
        <ModalHeader
          toggle={() => {
            setIsCreateProposalModalVisible(!isCreateProposalModalVisible)
            setIsEditedTemplate(null)
          }}
          className={s.modalHeader}
        >
          Add Proposal Template
        </ModalHeader>
        <ModalBody className={s.modalBody}>
          <div className={s.content}>
            <EditProposalTemplate
              title={template?.title}
              templateType={templateType}
              hasTitle
              editedProposalTemplate={template?.content}
              saveActions={[
                {
                  text: 'Save',
                  cb: (body, base64body, { title }) => {
                    saveTemplate(body, title)
                  },
                  className: s.greenBtn,
                  cy: 'save_btn'
                },
                {
                  text: 'Cancel',
                  cb: () => {
                    setIsCreateProposalModalVisible(false)
                    setIsEditedTemplate(null)
                  },
                  enabled: true
                }
              ]}
            />
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default CreateProposalModal
